import { ICreateVoucherDto } from '@lib/interfaces';

export function createVoucherBodyUtil(formData: any): ICreateVoucherDto {
  const sum = (formData.goods as Array<any>).reduce((prev: number, cur: any) => {
    const currSum = cur.price * cur.count;

    return prev + currSum;
  }, 0);

  const result: ICreateVoucherDto = {
    customerId: formData.customerId,
    comment: formData.comment,
    fd: formData.fd,
    fn: formData.fn,
    fp: formData.fp,
    checkDate: formData.checkDate,
    imageLink: formData.imageLink,
    sum,
    goods: formData.goods.map(item => {
      return {
        goodId: item.id,
        count: item.count,
        price: item.price,
      };
    }),
  };

  return result;
}
